import {
    Component, Input, Output, EventEmitter, ContentChildren, QueryList,
    TemplateRef, ContentChild, ViewChildren, OnInit
} from '@angular/core';

import {
    RowCallback, AwesomeDataTableParams, AwesomeDataTableSortCallback,
    AwesomeDataTableTranslations, defaultTranslations
} from './../shared';
import { AwesomeDataTableColumn } from './../column/column.directive';
import { AwesomeDataTableRow } from './../row/row.component';
import { drag } from './../shared';

@Component({
    selector: 'adata-table',
    template: `<div class="adata-table-wrapper">
    <adata-table-header *ngIf="header"></adata-table-header>

    <div class="adata-table-box">
        <table class="table adata-table" [ngClass]="cssClass">
            <thead>
                <tr>
                    <th [hide]="!expandColumnVisible" class="expand-column-header">
                    <th [hide]="!indexColumnVisible" class="index-column-header">
                        <span [textContent]="indexColumnHeader"></span>
                    </th>
                    <th [hide]="!selectColumnVisible" class="select-column-header">
                        <label [hide]="!multiSelect" class="custom-control custom-checkbox">
                            <input [(ngModel)]="selectAllCheckbox" 
                                    name="radio-stacked" type="checkbox" class="custom-control-input">
                            <span class="custom-control-indicator"></span>
                        </label>
                    </th>
                    <th *ngFor="let column of columns" #th [hide]="!column.visible" (click)="headerClicked(column, $event)"
                        [class.sortable]="column.sortable" [class.resizable]="column.resizable"
                        [ngClass]="column.styleClassObject" class="column-header" [style.width]="column.width | px"
                        [class.text-right]="column.alignRight"
                        [class.sorted]="column.property === sortBy">
                        <span *ngIf="!column.headerTemplate" [textContent]="column.header"></span>
                        <span *ngIf="column.headerTemplate" [ngTemplateOutlet]="column.headerTemplate" [ngTemplateOutletContext]="{column: column}"></span>
                        <span class="column-sort-icon" *ngIf="column.sortable">
                            <i class="fa fa-sort column-sortable-icon" [hide]="column.property === sortBy"></i>
                            <span [hide]="column.property !== sortBy">
                                <i class="fa fa-sort-asc" [hide]="sortAsc"></i>
                                <i class="fa fa-sort-desc" [hide]="!sortAsc"></i>
                            </span>
                        </span>
                        <span *ngIf="column.resizable" class="column-resize-handle" (mousedown)="resizeColumnStart($event, column, th)"></span>
                    </th>
                </tr>
            </thead>
            <tbody *ngFor="let item of items; let index=index" class="adata-table-row-wrapper"
                   adataTableRow #row [item]="item" [index]="index" (selectedChange)="onRowSelectChanged(row)"
                   (expandRowChange)="onRowExpandChanged(row)">
            </tbody>
            <tbody class="substitute-rows" *ngIf="pagination && substituteRows">
                <tr *ngFor="let item of substituteItems, let index = index"
                    [class.row-odd]="(index + items.length) % 2 === 0"
                    [class.row-even]="(index + items.length) % 2 === 1"
                    >
                    <td [hide]="!expandColumnVisible"></td>
                    <td [hide]="!indexColumnVisible">&nbsp;</td>
                    <td [hide]="!selectColumnVisible"></td>
                    <td *ngFor="let column of columns" [hide]="!column.visible">
                </tr>
            </tbody>            
        </table>
        <div class="loading-cover" *ngIf="showReloading && reloading"></div>
    </div>

    <div *ngIf="noDataTemplate && !reloading && (!items || items.length === 0)">
        <ng-template *ngTemplateOutlet="noDataTemplate"></ng-template>
    </div>

    <adata-table-pagination *ngIf="pagination"></adata-table-pagination>
</div>`,
    styles: [`:host /deep/ .adata-table.table>tbody+tbody{border-top:none}:host /deep/ .adata-table.table td{vertical-align:middle}:host /deep/ .table-striped .row-even:hover,:host /deep/ .table-striped .row-odd{background-color:rgba(162,162,162,.06)}:host /deep/ .table-striped .row-even{background-color:transparent}.adata-table{margin-bottom:0}.adata-table .column-header{position:relative}.adata-table .expand-column-header{width:50px}.adata-table .select-column-header{width:50px;text-align:center}.adata-table .index-column-header{width:40px}.adata-table .column-header.sortable{cursor:pointer}.adata-table .column-header .column-sort-icon{margin-left:5px}.adata-table .column-header.sortable:not(:hover):not(.sorted) .column-sort-icon{visibility:hidden}.adata-table .column-header.resizable .column-sort-icon{margin:0 8px}.adata-table .column-header .column-sort-icon .column-sortable-icon{color:#d3d3d3}.adata-table .column-header .column-resize-handle{position:absolute;top:0;right:0;margin:0;padding:0;width:8px;height:100%;cursor:col-resize}.adata-table-box{position:relative;overflow-x:auto;-ms-overflow-style:-ms-autohiding-scrollbar;padding-bottom:15px}.adata-table-box .loading-cover{position:absolute;width:100%;height:100%;background-color:#a2a2a2;top:0}:host /deep/ .select-column .custom-control,:host /deep/ .select-column-header .custom-control{display:block;margin:0 auto;width:21px}.table td,.table th,.table tr{border-bottom-color:rgba(162,162,162,.26)!important;border-right-color:rgba(162,162,162,.26)!important}.table thead>tr>td{vertical-align:middle}.table>thead>tr>th{border-bottom-width:1px;border-color:rgba(162,162,162,.16);position:relative;text-overflow:ellipsis;font-weight:700;line-height:initial;letter-spacing:0;height:auto;font-size:12px;padding:.75rem .75rem 8px!important;vertical-align:middle}.table:not(.table-bordered) tbody:first-child tr:first-child td,.table:not(.table-bordered) thead th{border-top:none}.table:not(.table-bordered):not(.table-no-first-last-border)>tbody:last-child,.table:not(.table-bordered):not(.table-no-first-last-border)>tbody:last-child>tr:last-child>td,.table:not(.table-bordered):not(.table-no-first-last-border)>thead>tr>td,.table:not(.table-bordered):not(.table-no-first-last-border)>thead>tr>th{border-bottom:2px solid rgba(162,162,162,.26)}td.date,td.money{min-width:140px}`]
})
export class AwesomeDataTable implements AwesomeDataTableParams, OnInit {

    public _items: any[] = [];

    @Input('items') get items() {
        return this._items;
    }

    set items(items: any[]) {
        this._items = items;
        if (this.reloading) {
            this._onReloadFinished();
        }
    }

    @Input() public totalItems: number = null;
    get itemCount(): number {
        return this.totalItems
            ? this.totalItems
            : this._items.length;
    }

    // UI components

    @ContentChildren(AwesomeDataTableColumn) columns: QueryList<AwesomeDataTableColumn>;
    @ViewChildren(AwesomeDataTableRow) rows: QueryList<AwesomeDataTableRow>;
    @ContentChild('dataTableExpand') expandTemplate: TemplateRef<any>;
    @Input() noDataTemplate: TemplateRef<any>;

    // One-time optional bindings with default values

    @Input() headerTitle: string;
    @Input() header = true;
    @Input() pagination = true;
    @Input() indexColumn = false;
    @Input() indexColumnHeader = '';
    @Input() rowColors: RowCallback;
    @Input() rowTooltip: RowCallback;
    @Input() selectColumn = false;
    @Input() multiSelect = true;
    @Input() substituteRows = false;
    @Input() expandableRows = false;
    @Input() translations: AwesomeDataTableTranslations = defaultTranslations;
    @Input() selectOnRowClick = false;
    @Input() autoReload = false;
    @Input() showReloading = false;
    @Input() showDownloadButton = false;
    @Input() showReloadButton = true;
    @Input() showColumnSelectorButton = true;
    @Input() cssClass = 'table-hover';

    // UI state without input

    indexColumnVisible: boolean;
    selectColumnVisible: boolean;
    expandColumnVisible: boolean;

    // UI state: visible ge/set for the outside with @Input for one-time initial values

    public _sortBy: string;
    public _sortAsc = true;
    public _customSort: AwesomeDataTableSortCallback;

    public _offset = 0;
    public _limit = 10;

    @Input() get sortBy() {
        return this._sortBy;
    }

    set sortBy(value) {
        this._sortBy = value;
        this._triggerReload();
    }

    @Input()
    get sortAsc() {
        return this._sortAsc;
    }

    set sortAsc(value) {
        this._sortAsc = value;
        this._triggerReload();
    }

    @Input()
    get customSort() {
        return this._customSort;
    }

    set customSort(value) {
        this._customSort = value;
        this._triggerReload();
    }

    @Input()
    get offset() {
        return this._offset;
    }

    set offset(value) {
        this._offset = value;
        this._triggerReload();
    }

    @Input()
    get limit() {
        return this._limit;
    }

    set limit(value) {
        this._limit = value;
        this._triggerReload();
    }

    // calculated property:

    @Input()
    get page() {
        return Math.floor(this.offset / this.limit) + 1;
    }

    set page(value) {
        this.offset = (value - 1) * this.limit;
    }

    get lastPage() {
        return Math.ceil(this.itemCount / this.limit);
    }

    // setting multiple observable properties simultaneously

    sort(sortBy: string, asc: boolean, customSort: AwesomeDataTableSortCallback) {
        this.sortBy = sortBy;
        this.sortAsc = asc;
        this.customSort = customSort;
    }

    // init

    ngOnInit() {
        this._initDefaultValues();
        this._initDefaultClickEvents();
        this._updateDisplayParams();

        if (this.autoReload && this._scheduledReload == null) {
            this.reloadItems();
        }
    }

    public _initDefaultValues() {
        this.indexColumnVisible = this.indexColumn;
        this.selectColumnVisible = this.selectColumn;
        this.expandColumnVisible = this.expandableRows;
    }

    public _initDefaultClickEvents() {
        this.headerClick.subscribe((tableEvent: any) => this.sortColumn(tableEvent.column));
        if (this.selectOnRowClick) {
            this.rowClick.subscribe((tableEvent: any) => tableEvent.row.selected = !tableEvent.row.selected);
        }
    }

    // Reloading:
    _reloading = false;

    get reloading() {
        return this._reloading;
    }

    @Output() reload = new EventEmitter();

    reloadItems() {
        this._reloading = true;
        this.reload.emit(this._getRemoteParameters());
    }

    public _onReloadFinished() {
        this._updateDisplayParams();

        this._selectAllCheckbox = false;
        this._reloading = false;
    }

    // params of the last finished reload
    _displayParams = <AwesomeDataTableParams>{};

    get displayParams() {
        return this._displayParams;
    }

    _updateDisplayParams() {
        this._displayParams = {
            sortBy: this.sortBy,
            customSort: this.customSort,
            sortAsc: this.sortAsc,
            offset: this.offset,
            limit: this.limit
        };
    }

    _scheduledReload: any = null;

    // for avoiding cascading reloads if multiple params are set at once:
    _triggerReload() {
        if (this._scheduledReload) {
            clearTimeout(this._scheduledReload);
        }
        this._scheduledReload = setTimeout(() => {
            this.reloadItems();
        });
    }

    // Download
    @Output() download = new EventEmitter();

    downloadItems() {
        this.download.emit(this._getRemoteParameters());
    }

    // event handlers:

    @Output() rowClick = new EventEmitter();
    @Output() rowDoubleClick = new EventEmitter();
    @Output() headerClick = new EventEmitter();
    @Output() cellClick = new EventEmitter();
    @Output() rowExpandChange = new EventEmitter();
    @Output() rowSelectChange = new EventEmitter();

    public rowClicked(row: AwesomeDataTableRow, event: Event) {
        this.rowClick.emit({row, event});
    }

    public rowDoubleClicked(row: AwesomeDataTableRow, event: Event) {
        this.rowDoubleClick.emit({row, event});
    }

    public headerClicked(column: AwesomeDataTableColumn, event: MouseEvent) {
        this.page = 1;
        if (!this._resizeInProgress) {
            this.headerClick.emit({column, event});
        } else {
            this._resizeInProgress = false; // this is because I can't prevent click from mousup of the drag end
        }
    }

    public cellClicked(column: AwesomeDataTableColumn, row: AwesomeDataTableRow, event: MouseEvent) {
        this.cellClick.emit({row, column, event});
    }

    // functions:

    public _getRemoteParameters(): AwesomeDataTableParams {
        const params = <AwesomeDataTableParams>{};

        if (this.sortBy) {
            params.sortBy = this.sortBy;
            params.customSort = this.customSort;
            params.sortAsc = this.sortAsc;
        }
        if (this.pagination) {
            params.offset = this.offset;
            params.limit = this.limit;
        }
        return params;
    }

    public sortColumn(column: AwesomeDataTableColumn) {
        if (column.sortable) {
            const ascending = this.sortBy === column.property ? !this.sortAsc : true;
            this.sort(column.property, ascending, column.customSort);
        }
    }

    get columnCount() {
        let count = 0;
        count += this.indexColumnVisible ? 1 : 0;
        count += this.selectColumnVisible ? 1 : 0;
        count += this.expandColumnVisible ? 1 : 0;
        this.columns.toArray().forEach(column => {
            count += column.visible ? 1 : 0;
        });
        return count;
    }

    public getRowColor(item: any, index: number, row: AwesomeDataTableRow) {
        if (this.rowColors !== undefined) {
            return (<RowCallback>this.rowColors)(item, row, index);
        }
    }

    // selection

    selectedRow: AwesomeDataTableRow;
    selectedRows: AwesomeDataTableRow[] = [];

    public _selectAllCheckbox = false;

    get selectAllCheckbox() {
        return this._selectAllCheckbox;
    }

    set selectAllCheckbox(value) {
        this._selectAllCheckbox = value;
        this._onSelectAllChanged(value);
    }

    public _onSelectAllChanged(value: boolean) {
        this.rows.toArray().forEach(row => row.selected = value);
    }

    onRowSelectChanged(row: AwesomeDataTableRow) {
        // maintain the selectedRow(s) view
        if (this.multiSelect) {
            const index = this.selectedRows.indexOf(row);
            if (row.selected && index < 0) {
                this.selectedRows.push(row);
            } else if (!row.selected && index >= 0) {
                this.selectedRows.splice(index, 1);
            }
        } else {
            if (row.selected) {
                this.selectedRow = row;
            } else if (this.selectedRow === row) {
                this.selectedRow = row;
            }
        }

        // unselect all other rows:
        if (row.selected && !this.multiSelect) {
            this.rows.toArray().filter(row_ => row_.selected).forEach(row_ => {
                if (row_ !== row) { // avoid endless loop
                    row_.selected = false;
                }
            });
        }
        this.rowSelectChange.emit(row);
    }

    onRowExpandChanged(row: AwesomeDataTableRow) {
        this.rowExpandChange.emit(row);
    }

    // other

    get substituteItems() {
        return Array.from({length: this.displayParams.limit - this.items.length});
    }

    // column resizing

    public _resizeInProgress = false;

    public resizeColumnStart(event: MouseEvent, column: AwesomeDataTableColumn, columnElement: HTMLElement) {
        this._resizeInProgress = true;

        drag(event, {
            move: (moveEvent: MouseEvent, dx: number) => {
                if (this._isResizeInLimit(columnElement, dx)) {
                    column.width = columnElement.offsetWidth + dx;
                }
            },
        });
    }

    resizeLimit = 30;

    public _isResizeInLimit(columnElement: HTMLElement, dx: number) {
        // This is needed because CSS min-width didn't work on table-layout: fixed.
        // Without the limits, resizing can make the next column disappear completely,
        // and even increase the table width. The current implementation suffers from the fact,
        // that offsetWidth sometimes contains out-of-date values.
        if ((dx < 0 && (columnElement.offsetWidth + dx) <= this.resizeLimit) || !columnElement.nextElementSibling || // resizing doesn't make sense for the last visible column
            (dx >= 0 && ((<HTMLElement> columnElement.nextElementSibling).offsetWidth + dx) <= this.resizeLimit)) {
            return false;
        }
        return true;
    }

    public rowsLimitList: number[] = [];

    public getRowsLimitList(): number[] {
        if (this.rowsLimitList.length === 0) {
            this.rowsLimitList = [5, 10, 25, 50, 100, 200];
        }
        return this.rowsLimitList;
    }
}
